module.exports = __webpack_public_path__ + "static/media/credit-card_discover.a00f6208.svg";